var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{ref:"refInsightChartLine",staticClass:"inslnchart",attrs:{"type":"line","height":"550","options":_vm.chartOptionsLine,"series":_vm.series}})}
var staticRenderFns = []

export { render, staticRenderFns }